import React from "react";
import "./CardGrid.scss";

import Cotton from "../../../assets/images/leads/Cotton.png";
import Rayon from "../../../assets/images/leads/Rayon.jpg";
import Polyester from "../../../assets/images/leads/Polyester.jpg";
import Denim from "../../../assets/images/leads/Denim.jpg";
import chevronRight from "../../../assets/images/chevron_bottom.svg";

const CARDS = [
  { key: "Cotton", label: "Cotton", img: Cotton },
  { key: "Rayon", label: "Rayon", img: Rayon },
  { key: "Polyester", label: "Polyester", img: Polyester },
  { key: "Denim", label: "Denim", img: Denim },
];

export default function CardGrid({ onCardClick }) {
  function handleCardClick(type) {
    if (window.gtag) {
      window.gtag("event", "leads_card_click", {
        event_category: "engagement",
        event_label: type,
        value: 1,
      });
    }
    onCardClick(type);
  }
  return (
    <div className="leads_card_grid">
      {CARDS.map((c) => (
        <div
          className="leads_fabric_card"
          key={c.key}
          onClick={() => handleCardClick(c.key)}
          style={{ backgroundImage: `url(${c.img})` }}
        >
          <span className="leads_fabric_label">{c.label}</span>
          <div className="leads_chev">
            <img src={chevronRight} alt="icon" />
          </div>
        </div>
      ))}
    </div>
  );
}
